import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-body py-3" }
const _hoisted_2 = { class: "table-responsive" }
const _hoisted_3 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-center" }, "Tipe"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px; text-center" }, "File"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Tanggal Mulai"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Tanggal Selesai"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/download.svg",
  alt: ""
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/edit.svg",
  alt: ""
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "7",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_23 = [
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _hoisted_4,
          (this.tableData.length)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_6, _toDisplayString(item.typ), 1),
                    _createElementVNode("td", _hoisted_7, _toDisplayString(item.documentUrl), 1),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.getMoment(item.startDate)), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.getMoment(item.expiredDate )), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(item.status), 1),
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("a", {
                        class: "symbol symbol-35px me-2",
                        "data-bs-toggle": "tooltip",
                        title: "Unduh",
                        style: {"cursor":"pointer"},
                        onClick: ($event: any) => (_ctx.download(index, item))
                      }, _hoisted_14, 8, _hoisted_12),
                      _createElementVNode("a", {
                        class: "symbol symbol-35px me-2",
                        "data-bs-toggle": "tooltip",
                        title: "Edit",
                        style: {"cursor":"pointer"},
                        onClick: ($event: any) => (_ctx.$router.push('/superadmin/legal/legalitas/detail/update/' + this.$route.params.id + '/' + item.id))
                      }, _hoisted_17, 8, _hoisted_15),
                      _createElementVNode("a", {
                        class: "symbol symbol-35px me-2",
                        "data-bs-toggle": "tooltip",
                        title: "Hapus",
                        style: {"cursor":"pointer"},
                        onClick: ($event: any) => (_ctx.handleDelete(index, item))
                      }, _hoisted_20, 8, _hoisted_18)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_21, _hoisted_23))
        ])
      ])
    ])
  ], 2))
}